import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { amplitudeLogout } from 'apps/auth/components/utils/AmplitudeUtils';
import ModalError from 'apps/auth/components/utils/ModalError';
import { LOGIN } from 'apps/auth/constants/UrlConstants';
import { getFullEncodeApiUrl } from 'apps/auth/helpers/api';
import { logInfo, logWarn, logError } from 'apps/auth/helpers/clientLogger';
import { addScript, removeScript } from 'apps/auth/helpers/DOM';
import { deletingWhiteSpaceInString } from 'apps/auth/helpers/utils';

import { ButtonContainer } from './styles';

const GooglePayButton = (props) => {
    let payButton = null;
    const googlePayRef = useRef(null);
    const GOOGLE_PAY_API = 'https://pay.google.com/gp/p/js/pay.js';
    let paymentsClient = null;

    useEffect(() => {
        addScript(GOOGLE_PAY_API, initPaymentsClient);
        return () => removeScript(GOOGLE_PAY_API);
    }, []);

    const baseRequest = {
        apiVersion: 2,
        apiVersionMinor: 0,
    };
    const tokenizationSpecification = {
        type: 'PAYMENT_GATEWAY',
        parameters: {
            gateway: props.google_gateway,
            gatewayMerchantId: props.google_checkout_merchant_id,
        },
    };
    const allowedCardNetworks = ['MASTERCARD', 'VISA'];
    const allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];
    const baseCardPaymentMethod = {
        type: 'CARD',
        parameters: {
            allowedAuthMethods: allowedCardAuthMethods,
            allowedCardNetworks: allowedCardNetworks,
        },
    };
    const cardPaymentMethod = Object.assign({ tokenizationSpecification: tokenizationSpecification }, baseCardPaymentMethod);

    const isReadyToPayRequest = Object.assign({}, baseRequest);
    isReadyToPayRequest.allowedPaymentMethods = [baseCardPaymentMethod];

    const paymentDataRequest = Object.assign({}, baseRequest);
    paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
    paymentDataRequest.merchantInfo = {
        merchantName: props.paysend_google_display_name,
        merchantId: props.google_merchant_id,
    };

    const onGooglePaymentButtonClicked = () => {
        const retrievedObject = localStorage.getItem('totalPrice');

        paymentDataRequest.transactionInfo = {
            totalPriceStatus: 'FINAL',
            totalPrice: deletingWhiteSpaceInString(JSON.parse(retrievedObject).value.formattedValue),
            currencyCode: props.currencyCode, //if send
            countryCode: props.countryCode, //add countryCode
            // transactionId: '123'// add transactionId if send
        };

        paymentsClient
            .loadPaymentData(paymentDataRequest)
            .then((paymentData) => {
                logInfo({ paymentData }, { paymentDataRequest });
                processPayment(paymentData);
            })
            .catch((err) => {
                logError(err);
            });
    };
    const processPayment = ({ paymentMethodData: { tokenizationData } }) => {
        props.toggleSpinner(true);

        fetch(
            getFullEncodeApiUrl(
                `/auth/ga/pocket/${props.id}/top-up/google-pay/pay` +
                    '?token=' +
                    encodeURIComponent(tokenizationData.token) +
                    '&totalValue= ' +
                    paymentDataRequest.transactionInfo.totalPrice,
            ),
            {
                method: 'POST',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                },
            },
        )
            .then((response) => {
                if (response.status === 403) {
                    window.location.replace(LOGIN);
                    amplitudeLogout();
                    return;
                }
                if (response.status === 500) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then((json) => {
                if (json.redirectTo) {
                    window.location.href = json.redirectTo;
                }
                if (json.errors && Object.keys(json.errors).length > 0) {
                    if (json.errors.error) {
                        props
                            .toggleSpinner(false)
                            .then(() =>
                                props.toggleModal(
                                    true,
                                    <ModalError
                                        mainText={json.errors.error.body}
                                        primaryButtonCaption={props.goBack}
                                        buttonRowCaption={props.contactSupport}
                                        primaryButtonOnClick={() => props.toggleModal(false)}
                                        buttonRowOnClick={() => props.toggleChat(true)}
                                    />,
                                ),
                            );
                    }
                }
            })
            .catch((error) => {
                logWarn(error);
                props.toggleSpinner(false);
            });
    };

    const initPaymentsClient = () => {
        if (paymentsClient === null) {
            paymentsClient = new google.payments.api.PaymentsClient({ environment: __isDev__ ? 'TEST' : 'PRODUCTION' });

            paymentsClient
                .isReadyToPay(isReadyToPayRequest)
                .then((res) => {
                    if (res.result) {
                        // add a Google Pay payment button
                        payButton = paymentsClient.createButton({ onClick: () => onGooglePaymentButtonClicked() });
                        googlePayRef.current.appendChild(payButton);
                    }
                })
                .catch((err) => {
                    logError(err);
                });
        }
    };
    const isDisabledButton = parseFloat(props.amount) === 0 || !props.amount || props.amountField.isError;
    return <ButtonContainer isDisabled={isDisabledButton} ref={googlePayRef} />;
};

const mapStateToProps = (state) => {
    return {
        paysend_google_display_name: state.messages.jsMessages['paysend.google.display.name'],
        google_gateway: state.extra.google_gateway,
        google_checkout_merchant_id: state.extra.google_checkout_merchant_id,
        google_merchant_id: state.extra.google_merchant_id,
        currencyCode: state.extra.account.pocketCurrency.code,
        countryCode: state.extra.countryCode,
        goBack: state.messages.pageMessages.goBack,
        contactSupport: state.messages.pageMessages.contactSupport,
        id: state.extra.id,
    };
};
export default connect(mapStateToProps, { toggleSpinner, toggleModal, toggleChat })(GooglePayButton);
